import React from "react";
import { Flex } from "rebass";
import styled from "styled-components";

const CardLayout = styled(Flex)`
  align-items: stretch;

  @media (max-width: 40em) {
    flex-wrap: wrap;
    > * {
      width: 100%;
      margin-bottom: ${(props) => props.theme.space[1]}px;

      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:last-child {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
  @media (min-width: 40em) and (max-width: 75em) {
    flex-wrap: wrap;
    > * {
      width: ${(props) =>
        "calc(" + (1 / 2) * 100 + "% - " + props.theme.space[4] / 2 + "px)"};
      margin-bottom: ${(props) => props.theme.space[5]}px;

      &:not(:lang(ar)) {
        margin-left: ${(props) => props.theme.space[4]}px;
      }
      &:lang(ar) {
        margin-right: ${(props) => props.theme.space[4]}px;
      }
    }
    > *:nth-child(2n + 1) {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    /* > *:nth-last-child(-n + 2) {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    } */
  }
  @media (min-width: 75em) {
    flex-wrap: wrap;
    > * {
      width: ${(props) =>
        "calc(" +
        (1 / 4) * 100 +
        "% - " +
        props.theme.space[4] / (1 / 3 + 1) +
        "px)"};
      margin-bottom: ${(props) => props.theme.space[5]}px;

      &:not(:lang(ar)) {
        margin-left: ${(props) => props.theme.space[4]}px;
      }
      &:lang(ar) {
        margin-right: ${(props) => props.theme.space[4]}px;
      }
    }
    > *:nth-child(4n + 1) {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    /* > *:nth-last-child(-n + 4) {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    } */
  }
`;

export default CardLayout;



// WEBPACK FOOTER //
// ./src/components/CardLayout.js